import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Utilities_monthly_frequency_dd_ComponentContextService } from './Utilities.monthly_frequency_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Utilities.frontend.types'
import { $frontendTypes as $types} from './Utilities.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Utilities-monthly_frequency_dd_single',
  templateUrl: './Utilities.monthly_frequency_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Utilities_monthly_frequency_dd_singleComponent),
      multi: true
    }
  ]
})
export class Utilities_monthly_frequency_dd_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }

  options: Array<{ key: any; name: string; disabled?: boolean; }> = [
    {
      key: '1',
      name: '1',
      disabled: null
    },  
    {
      key: '2',
      name: '2',
      disabled: null
    },  
    {
      key: '3',
      name: '3',
      disabled: null
    },  
    {
      key: '4',
      name: '4',
      disabled: null
    },  
    {
      key: '5',
      name: '5',
      disabled: null
    },  
    {
      key: '6',
      name: '6',
      disabled: null
    },  
    {
      key: '7',
      name: '7',
      disabled: null
    },  
    {
      key: '8',
      name: '8',
      disabled: null
    },  
    {
      key: '9',
      name: '9',
      disabled: null
    },  
    {
      key: '10',
      name: '10',
      disabled: null
    },  
    {
      key: '11',
      name: '11',
      disabled: null
    },  
    {
      key: '12',
      name: '12',
      disabled: null
    },  
    {
      key: '13',
      name: '13',
      disabled: null
    },  
    {
      key: '14',
      name: '14',
      disabled: null
    },  
    {
      key: '15',
      name: '15',
      disabled: null
    },  
    {
      key: '16',
      name: '16',
      disabled: null
    },  
    {
      key: '17',
      name: '17',
      disabled: null
    },  
    {
      key: '18',
      name: '18',
      disabled: null
    },  
    {
      key: '19',
      name: '19',
      disabled: null
    },  
    {
      key: '20',
      name: '20',
      disabled: null
    },  
    {
      key: '21',
      name: '21',
      disabled: null
    },  
    {
      key: '22',
      name: '22',
      disabled: null
    },  
    {
      key: '23',
      name: '23',
      disabled: null
    },  
    {
      key: '24',
      name: '24',
      disabled: null
    },  
    {
      key: '25',
      name: '25',
      disabled: null
    },  
    {
      key: '26',
      name: '26',
      disabled: null
    },  
    {
      key: '27',
      name: '27',
      disabled: null
    },  
    {
      key: '28',
      name: '28',
      disabled: null
    },  
    {
      key: '29',
      name: '29',
      disabled: null
    },  
    {
      key: '30',
      name: '30',
      disabled: null
    },  
    {
      key: '31',
      name: '31',
      disabled: null
    },  
    {
      key: 'L',
      name: 'Last day of the month',
      disabled: null
    },  
  ];


  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Utilities_ShellService,
    private $datasources: Utilities_DatasourceService,
    private $flows: Utilities_FlowService,
    private $reports: Utilities_ReportService,
    private $localization: Utilities_LocalizationService,
    private $operations: Utilities_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Utilities_monthly_frequency_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): string | string[] {
    return this._innerValue;
  }

  set value(val: string | string[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }


  displayWithFn(value: any): Promise<string> {
    const displayTextResult = this.options.find(o => o.key === value).name;
    this.displayTextChange.emit(displayTextResult);
    return Promise.resolve(displayTextResult);
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (filterText.length > 0) {
      const list = this.options.filter(item => item.name.startsWith(filterText))
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    } else {
      const list = [...this.options];
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    }
  }

}
